import React, { useState } from "react";
import { Accordion, Container, Row, Col } from "react-bootstrap";

const Question = () => {
  const [activeKeys, setActiveKeys] = useState([]);

  const handleToggle = (eventKey) => {
    setActiveKeys((prev) =>
      prev.includes(eventKey)
        ? prev.filter((key) => key !== eventKey)
        : [...prev, eventKey]
    );
  };

  return (
    <Container className="my-5">
      <h2 className="text-center mb-4 fs-40">FAQs</h2>
      <Row className="p-4">
        <Col md={12}>
          <Accordion activeKey={activeKeys}>
            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="0"
              onClick={() => handleToggle("0")}
            >
              <Accordion.Header className="red-header">
                How will Alignar treatment straighten my teeth?
              </Accordion.Header>
              <Accordion.Body>
                A unique, digital treatment plan that maps out the exact
                movements of your teeth is created. Your Alignar clear aligners
                are then designed to apply the right amount of force to the
                right place at the right time based on your plan. We will be
                with you every step of the way to monitor your progress and
                ensure your aligners fit correctly.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="1"
              onClick={() => handleToggle("1")}
            >
              <Accordion.Header className="red-header">
                How long will treatment take?
              </Accordion.Header>
              <Accordion.Body>
                The length of treatment depends on multiple factors, like how
                complex your case is and how often you wear your aligners. We
                will determine how long your treatment could take based on your
                specific needs. On average, Alignar treatment time is 3 to 9
                months, though you will start seeing results in a matter of
                weeks.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="2"
              onClick={() => handleToggle("2")}
            >
              <Accordion.Header className="red-header">
                Are there any restrictions on what I can eat while in treatment?
              </Accordion.Header>
              <Accordion.Body>
                None! Alignar clear aligners are removable, so there are no food
                restrictions. With traditional wires and brackets, there’s a
                long list of foods you unfortunately can’t enjoy, as they can
                damage or get stuck in your braces.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="3"
              onClick={() => handleToggle("3")}
            >
              <Accordion.Header className="red-header">
                How much does Alignar cost and do you offer finance?
              </Accordion.Header>
              <Accordion.Body>
                Like other types of orthodontic treatment, the price of the
                Alignar treatment depends on the complexity of your dental
                correction and your course of treatment.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="4"
              onClick={() => handleToggle("4")}
            >
              <Accordion.Header className="red-header">
                Is Alignar treatment painful?
              </Accordion.Header>
              <Accordion.Body>
                Alignar treatment moves your teeth by applying gentle, constant
                force, but some people do feel temporary discomfort for the
                first few days of wearing a new set of aligners.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>
      </Row>
    </Container>
  );
};

export default Question;
